import React from 'react'
import clsx from 'clsx'
import Link from 'next/link'
import { displayFont } from 'fuse_common/utils/ui/fonts'
import { FuseLogo } from 'fuse_common/components/ui/icons/fuse'

export const Logo: React.FC<Omit<React.ComponentProps<typeof Link>, 'href'>> = ({ className, ...props }) => {
  return (
    <Link
      href="/"
      className={clsx(
        'relative text-[38px] leading-[6px] tracking-[0.922px] p-4 pl-0 font-[500] text-white outline-none focus-visible:ring-2 ring-fuse-orange inline-block',
        displayFont.className,
        className,
      )}
      {...props}
    >
      Fuse
      <FuseLogo className="absolute top-0 right-0 size-3" />
    </Link>
  )
}
